<template>
	<div class="meetingWrap">
		<div class="meeting-list">
			<div v-for="(item,index) in liveList" :key="index" @click="skipLive(item)">
				<!-- <router-link :to="{path:'/meeting/live',query:{'id':item.id,'meeting_id':item.meeting_id}}">	 -->
						<div class="cover">
							<img :src="item.banner" alt="" onerror="common.imgError(2,event)" v-if="item.banner!=null">
							<img src="null" alt="" onerror="common.imgError(2,event)" v-if="item.banner==null">
							<div class="skip">
								<img src="../../assets/images/Meeting/Meeting_skip.png" alt="">
							</div>
						</div>
						<h4>{{item.name}}</h4>
				<!-- </router-link>		 -->
			</div>
		</div>
		<Footer></Footer>
	</div>

</template>
<script>
	import {MeetingsPlace} from '../../config/interface.js';
	import Footer from '@/components/Footer.vue'
	export default{
		components:{
			Footer
		},
		data(){
			return{
				meeting_id:0,
				date:'',
				liveList:[]
			}
		},
		mounted(){
			this.meeting_id=this.$route.query.meeting_id;
			this.date=this.$route.query.date;
			this.getMeetingsPlace()
		},
		methods:{
			//会场
			getMeetingsPlace(id){
				const url=MeetingsPlace;
				const method='POST';
				let params={
					meeting_id:this.meeting_id,
					date:this.date
				}
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						let data=res.data;
						this.liveList=data;
					}
				})
			},
			//跳转直播
			skipLive(item){
				if(item.live_code){
					window.location.href=item.live_code;
				}else{
			        this.$router.push({
			          path:'/meeting/live',
			          query: {
						  meeting_id:item.meeting_id,
			            id: item.id
			            
			          }
					})
			}
		}
	}
}
</script>
<style lang="scss">
	.meetingWrap{
		position: relative;
		min-height:100%;
	}
	.meeting-list{
		padding:0 15px;
		padding-bottom:50px;
		.cover{
			position:relative;
			   margin:12px 0;
			img{
				width:100%;
				border-radius:5px;
			}
			.skip{
				position:absolute;
				right:20px;
				top:50%;
				transform:translate(0,-50%);
				img{
					width:50px;
					height:50px;
				}
			}
		}
		h4{
				font-size:15px;
				color:$color-black;
				line-height:30px;
		}
	}
</style>


// WEBPACK FOOTER //
// src/pages/meeting/List.vue